import images from 'config/images.json'
import { splitImageUrl } from 'src/utils/setImageUrl'

import { ImageType } from '../Picture.types'

interface GeneratePictureByTypeArgs {
  imageType: ImageType
  src: string
  version?: string
}

export function generatePictureByType({ imageType, src, version }: GeneratePictureByTypeArgs) {
  const currentImageType = images.types.find((t) => t.type === imageType)
  const { sizes, srcSetSizes, width, height } = currentImageType
  const { baseURL, ext } = splitImageUrl(src)
  const isPng = ext === 'png'

  let png = ''
  let webp = ''

  function generateSrcSetSizes(format: string) {
    return srcSetSizes.map((size) => `${baseURL}/${size}.${format}${version || ''} ${size.split('x')[0]}w`).join(', ')
  }

  switch (imageType) {
    case ImageType.BANNER:
      png = isPng ? generateSrcSetSizes('png') : ''
      webp = !isPng ? generateSrcSetSizes('webp') : ''
      break
    case ImageType['3D_TILE']:
      webp = src.replace('.png', '.webp')
      break
    case ImageType.TILE:
    case ImageType.BINGO_TILE:
    case ImageType.BACKGROUND:
    case ImageType.SCREENSHOT_MODAL:
    case ImageType.SCREENSHOT_CONTENT:
    case ImageType.SEARCH:
    case ImageType.PROMOTIONS:
      webp = generateSrcSetSizes('webp')
      break
    default:
      break
  }

  return {
    fallback: src,
    width,
    height,
    sizes,
    png,
    webp,
  }
}
